/* global window */
( function( window, $, undefined ) {
	var document = window.document,

	SKELET = {
		common: {
			init: function() {

				// Application-wide code

				// Form hints.
				$( ".help-hint" ).each( function() {
					var $this = $( this ),
						$field = $this.closest( ".form-group" ).find( ".form-control" ),
						title = $this.data( "title" ) || "",
						content = $this.html();

					$field.popover( {
						html: true,
						trigger: "focus",
						title: title,
						content: content
					} );
				} );
			}
		},

		main: {
			index: function() {
			}
		}
	};

	/*
	 * Garber-Irish DOM-based routing.
	 * See: http://goo.gl/z9dmd
	 */
	SKELET.UTIL = {
		exec: function( controller, action ) {
			var ns = SKELET;

			if ( action === undefined ) {
				action = "init";
			}

			if ( controller !== "" && ns[ controller ] &&
				typeof ns[ controller ][ action ] === "function" ) {
				ns[ controller ][ action ]();
			}
		},

		init: function() {
			var body = document.body,
			controller = body.getAttribute( "data-controller" ),
			action = body.getAttribute( "data-action" );

			SKELET.UTIL.exec( "common" );
			SKELET.UTIL.exec( controller );
			SKELET.UTIL.exec( controller, action );
		}
	};

	// Expose SKELET to the global object.
	window.SKELET = SKELET;

	// Initialize application.
	$( document ).ready( SKELET.UTIL.init );
} )( window, window.jQuery );
